import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddEditMeal from '../components/TrackerAddEditMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { TrackerAddMealProps } from '../types';

const TrackerAddDescribeMealContainer: React.FC<TrackerAddMealProps> = (props) => {
  return (
    <TrackerAddEditMeal
      key={props.mealData?.name}
      {...props}
      webviewModal={true}
      fromUserMeals={props.fromUserMeals}
    />
  );
};

export default withLoading(TrackerAddDescribeMealContainer, UniversalPlaceholder);
